// extracted by mini-css-extract-plugin
export default {"canvaContainer":"Canva_canvaContainer__7Lga0","imgLabel":"Canva_imgLabel__KrDAC","canvaButtons":"Canva_canvaButtons__PXhup"};